import { makeStyles } from '@material-ui/core/styles'

import { colors } from '@galo-monitor/styles'
import fonts from '@galo-monitor/styles/fonts'

const drawerWidth = 240

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flex: 1,
    overflowX: 'hidden',
    flexDirection: 'column'
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0
    }
  },
  footer: {
    height: 62,
    color: colors.lightGrey4,
    width: '100%',
    marginTop: 'auto',
    [theme.breakpoints.down('xs')]: {
      marginLeft: 0
    }
  },
  appBar: {
    marginLeft: drawerWidth,
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${ drawerWidth }px)`
    }
  },
  appBarDrawerOpened: {
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${ theme.spacing(7) }px)`
    }
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none'
    }
  },
  toolbar: {
    ...theme.mixins.toolbar,
    display: 'flex'
  },
  drawerPaper: {
    width: drawerWidth
  },
  container: {
    position: 'relative',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    overflow: 'auto',
    marginLeft: drawerWidth,
    transition: theme.transitions.create('margin-left', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    [theme.breakpoints.down('xs')]: {
      marginLeft: 0
    }
  },
  containerDrawerOpened: {
    transition: theme.transitions.create('margin-left', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(7)
    }
  },
  content: {
    padding: 20,
    flex: 1
  },
  menuItensContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 20
  },
  button: {
    fontSize: fonts.fontSize.L,
    paddingTop: 2,
    paddingBottom: 2,
    marginTop: 15
  },
  brandToolbarContainer: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-start',
    padding: '0 17px',
    alignItems: 'center'
  },
  toolbarRightContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    '& > * ': {
      marginLeft: 10
    }
  },
  toolbarRoot: {
    transition: 'all .2s',
    display: 'inline-flex',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between'
  },
  menuLink: {
    '& * ': {
      fontSize: '0.9rem',
      fontWeight: fonts.fontWeight.bold,
      color: `${ colors.white } !important`,
      fill: `${ colors.white } !important`
    }
  },
  listItemIcon: {
    minWidth: 40
  },
  menuActive: {
    '& * ': {
      color: `${ colors.primary } !important`,
      fill: `${ colors.primary } !important`
    }
  },
  companyName: {
    color: colors.white,
    paddingLeft: 15,
    fontSize: '1rem',
    fontWeight: fonts.fontWeight.bold
  },
  menuSectionTitle: {
    color: colors.darkGrey,
    padding: '15px 15px 3px',
    textTransform: 'uppercase',
    fontSize: '0.785em',
    fontWeight: fonts.fontWeight.bold
  },
  menuSectionContainer: {
    marginTop: 5,
    marginBottom: 5
  },
  userMenuButton: {
    boxShadow: 'none',
    background: colors.darkGrey,
    '&:hover': {
      background: colors.lightGrey4
    }
  },
  toolbarIconContainer: {
    margin: '0 10px'
  },
  drawerRoot: {
    backgroundColor: colors.black
  },
  drawerCompany: {
    backgroundColor: colors.darkGrey2
  },
  drawerFarm: {
    backgroundColor: colors.darkGrey4
  },
  drawerOpen: {
    width: drawerWidth
  },
  drawerClose: {
    width: theme.spacing(7),
    overflow: 'hidden'
  },
  brandToolbarContainerRoot: {
    backgroundColor: colors.dark
  },
  brandToolbarContainerCompany: {
    backgroundColor: colors.darkGrey3
  },
  brandToolbarContainerFarm: {
    backgroundColor: colors.darkGrey5
  },
  propertySelect: {
    marginBottom: 0
  },
  widthTransition: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  displayFlex: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
}))

export default useStyles
